window.addEventListener('DOMContentLoaded', () => {
  const btnSearchMobileEl = document.querySelector('.btn-search-mobile')
  const btnSearchDesktopEl = document.querySelector('.icon_search')
  const btnCloseEl = document.querySelector('.search-bar__close')

  btnCloseEl.addEventListener('click', () => {
    window.bodyScrollLock.clearAllBodyScrollLocks()
  })
})

window.addEventListener('scroll', () => {
  if (window.scrollY > 0) {
    document.body.classList.add('is-scroll')
  }
  else document.body.classList.remove('is-scroll')
})
